export function LoadingFeedback({ label = 'Procesando feedback...' }) {
	return (
		<div className='tw-bg-white tw-flex tw-justify-center tw-items-center tw-w-[474px] tw-h-44 tw-rounded-md tw-flex-col tw-gap-2'>
			<svg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg' className='tw-animate-spin'>
				<path
					d='M58.6673 32C58.6673 46.7276 46.7282 58.6667 32.0006 58.6667C17.2731 58.6667 5.33398 46.7276 5.33398 32C5.33398 17.2724 17.2731 5.33333 32.0006 5.33333C46.7282 5.33333 58.6673 17.2724 58.6673 32ZM10.6673 32C10.6673 43.7821 20.2186 53.3333 32.0006 53.3333C43.7827 53.3333 53.334 43.7821 53.334 32C53.334 20.2179 43.7827 10.6667 32.0006 10.6667C20.2186 10.6667 10.6673 20.2179 10.6673 32Z'
					fill='#E1E8F0'
					stroke='#E1E8F0'
					strokeWidth='4'
				/>
				<path
					d='M32.0007 8C32.0007 6.52724 30.8038 5.31952 29.3384 5.46655C25.3549 5.86623 21.5003 7.15919 18.0674 9.26293C13.8741 11.8325 10.4732 15.5117 8.24048 19.8936C6.00778 24.2755 5.03033 29.1895 5.41619 34.0922C5.73209 38.1061 6.95169 41.9845 8.96978 45.4421C9.71218 46.7141 11.3928 46.9725 12.5842 46.1068C13.7757 45.2412 14.0233 43.5799 13.3129 42.2898C11.8553 39.6426 10.9718 36.7066 10.7331 33.6738C10.4244 29.7516 11.2064 25.8204 12.9925 22.3149C14.7787 18.8093 17.4994 15.866 20.854 13.8103C23.4479 12.2208 26.3426 11.2099 29.3409 10.8331C30.8021 10.6495 32.0007 9.47276 32.0007 8Z'
					fill='#7A6BE8'
					stroke='#7A6BE8'
					strokeWidth='4'
				/>
			</svg>
			<p className='tw-font-bold tw-m-0 tw-p-0 tw-text-xl'>{label}</p>
		</div>
	)
}
